module.exports = __webpack_public_path__ + "media/images/icons/icon_up-549c149300c189b2019bf7c3e2111e3f.svg";